const exaKeyframes = {
  from: { opacity: 0 },
  to: { opacity: 1 },
};

export const profileButton = (theme) => ({
  '@global': {
    '@keyframes exa': exaKeyframes,
  },
  linkMui: {
    textDecoration: 'none',
    fontWeight: 500,
    fontFamily: 'Spezia',
    fontSize: '16px',
    color: theme.customPalette.neutralGy05,
    '& span': {
      marginBottom: '-5px',
      display: 'block',
    },
  },
  profileDropdownBase: {
    position: 'absolute',
    right: 0,
    width: 219,
    zIndex: 100,
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translateY(20px) scale(0.96)',
    transition: `opacity 300ms ease, transform 300ms ease`,
    '&.profileDropdownVisible': {
      opacity: 1,
      pointerEvents: 'auto',
      transform: 'translateY(0) scale(1)',
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
    '& ul': {
      '& li': {
        width: '100%',
        display: 'block',
      },
    },
  },
  profileArrow: {
    width: 16,
    height: 16,
    clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    zIndex: 1,
    transform: 'translateY(5%) translateX(-50%)',
    backgroundColor: '#662482',
  },
  userAreaList: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    borderBottom: '1px solid transparent',
    [theme.breakpoints.up('lg')]: {
      marginTop: '0 !important',
      borderBottom: '1px solid var(--grey02, #e6e6e6)',
    },
    '& p': {
      paddingBottom: '0 !important',
      fontSize: 16,
      color: theme.customPalette.neutralGy05,
      fontWeight: 500,
    },
  },
  userAreaItem: {
    display: 'inline',
    cursor: 'pointer',
    borderBottom: '1px solid #f2f2f2',
    '& $listItemText': {
      margin: '0 !important',
      padding: '0 20px !important',
    },
    '&.MuiListItem-gutters': {
      padding: '20px 0',
    },
  },
  mobileDrawer: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  listItemText: {
    margin: '0 !important',
    padding: '0 20px !important',
  },
  userAreaMobile: {
    width: '85vw',
  },
  userAreaUserName: {
    fontWeight: 600,
    fontSize: 20,
    fontFamily: 'Spezia',
  },
  userAreaLinkDesktop: {
    textDecoration: 'none',
    fontWeight: 500,
    fontFamily: 'Spezia',
    fontSize: 16,
  },
});
